import React, {useEffect, useState} from 'react';
import {GetUserDetails, goToPage, getRepId} from '../IdfSaleBlock/IdfSaleSlice';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import Header from '../IdfSaleBlock/Constans/Header';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import backgroundImage from './BackgroundWithLogos.png';
import Config from '../../../Config';
import useEffectAsync from '../../../utilities/hooks/useEffectAsync';
import {reAuthenticateThunk} from '../../../utilities/authentication/authenticationSlice';
import {Container, Row} from 'reactstrap';

function IdfLogin(props) {
  const [id, setId] = useState('');
  const [idfId, setIdfId] = useState('');

  useEffect(() => {
    props.getRepId();
  }, []);

  useEffectAsync(async () => {
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
    eventer(
      messageEvent,
      function (e) {
        if (e.data.eventType != 'returnFromLogin') {
          return;
        }
        console.log('parent received message!:  ', e.data);
        switch (e.data.status) {
          case 'loginSuccess':
            if (props.auth.loginData?.isFullAuthenticated) {
              EpiContext.navigateTo(props.contentData.saleUrl.value.url);
            } else {
              props.reAuthenticateThunk('');
            }

            break;
          case 'newCustomer':
            var storage = window.localStorage || window.sessionStorage;
            try {
              urlVariables = JSON.parse(storage.getItem('urlVariables'));
            } catch (e) {}
            break;
        }
      },
      false,
    );
  }, []);
  useEffectAsync(async () => {
    if (props.auth.loginData?.isFullAuthenticated) {
      try {
        EpiContext.navigateTo(props.contentData.saleUrl.value.url);
      } catch (error) {
        console.log(error);
      }
    }
  }, [props.auth?.loginData?.isFullAuthenticated]);

  const actions = props.contentData.coreProductActions.expandedValue;
  const returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase());
  const loginUrl = authenticationProvider.getIdfLoginUrl(returnUrl, '', '');
  const onButtonClick = async () => {
    const res = await props.GetUserDetails({id_number: id, idfid_number: idfId});
  };
  const imgFromEpi = props.contentData.backGroundImage?.value.url;
  const imgToDisplay = imgFromEpi != null ? Config.epiBaseUrl + imgFromEpi : backgroundImage;
  return (
    <>
      {!props.auth.loginData?.isFullAuthenticated && (
        <div className='idf-login-main'>
          <Header hideBackButton={true}></Header>
          <div
            className='photo-text-container'
            style={{
              backgroundImage: `url(${imgToDisplay})`,
            }}></div>
          <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
            <Row className='idf-title-bold justify-content-center d-flex'>כניסה לאיזור האישי</Row>
            <Row className='idf-sub-title justify-content-center d-flex'>התחברו למערכת כדי להצטרף לתוכנית הסלולר המשתלמת בישראל</Row>
          </Container>
          <div className='login-iframe-wrapper'>
            <iframe
              allowtransparency='true'
              src={loginUrl}
              frameBorder='0'
              width={'100%'}
              height={'100%'}
              scrolling='no'
              className='login-iframe'
              style={{
                backgroundImage:
                  'linear-gradient(to bottom,#fff3 0,var(--theme-bright) 100%), linear-gradient(to bottom,var(--theme-white,#fff),var(--theme-white,#fff));',
              }}
              title=''></iframe>
          </div>
          {/* <div className='login-actions'>
            {actions.map((action, i) => {
              return (
                <ServiceBoxRegular
                  key={i}
                  callback={() => EpiContext.navigateTo(action.actionUrl?.value)}
                  isHaveBadge={action.isNew?.value}
                  badgeText={'חדש'}
                  actionName={action.actionName?.value}
                  backgroundImage={Config.epiBaseUrl + action.actionIcon?.value?.url}
                />
              );
            })}
          </div> */}
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
  auth: state.authentication,
});

const mapDispatchToProps = {
  GetUserDetails,
  goToPage,
  reAuthenticateThunk,
  getRepId,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfLogin);
